export default {
  methods: {
    calculateDownPayment(value) {
      return Math.max(this.activePurchase.totalAmount - value, 0);
    },
    calculateExtraAmount(value) {
      return Math.max((this.activePurchase.totalAmount - value) * -1, 0);
    },
  },
};
